export { default } from "./queryFactory";
export { default as searchClients } from "./searchClients";
export { default as cardsForClient } from "./cardsForClient";
export { default as companies } from "./companies";
export { default as merchants } from "./merchants";
export { default as terminals } from "./terminals";
export { default as cardTransactions } from "./cardTransactions";
export { default as cardLimits } from "./cardLimits";
export { default as limitGroups } from "./limitGroups";
export { default as client } from "./client";
export { default as oktellPing } from "./oktellPing";
export { default as terminalTransactions } from "./terminalTransactions";
export { default as transaction } from "./transaction";
export { default as users } from "./users";
export { default as processingUsers } from "./processingUsers";
export { default as processingRoles } from "./processingRoles";



// WEBPACK FOOTER //
// ./src/model/gql/queries/index.js